class ProductSelector extends HTMLElement {
  constructor() {
    super();

    this.inputWrapper = '[data-input-wrapper]';

    // Variant 数据
    const variantsJson = this.querySelector('[type="application/json"]');

    this.variants = variantsJson
      ? JSON.parse(variantsJson.textContent)
      : [];

    // Product Form
    this.form = document.querySelector(
      `#ProductForm-${this.dataset.sectionId}`
    );

    // Purchase Options
    this.purchaseOptions = document.querySelector(
      `#Product-Purchase-Options-${this.dataset.sectionId}`
    );

    // Sticky / Product Bar
    this.productBar = document.querySelector(
      `#ProductBar-${this.dataset.sectionId}`
    );

    /*
     * Liquid 中 data-installments-form-id 本身已经是 #ID
     * 所以这里直接 querySelector 即可。
     */
    this.installmentsForm = this.dataset.installmentsFormId
      ? document.querySelector(this.dataset.installmentsFormId)
      : null;

    // 用来取消上一次商品信息请求
    this.renderRequestController = null;

    // Variant change
    this.addEventListener(
      'change',
      this.onVariantChange.bind(this)
    );

    // 初始化
    this.updateOptions();

    // this.updateVariantStatuses();

    this.updateVariant();

    this.initUpdateMedia();

    if (this.currentVariant && this.form) {
      this.form.toggleAddButton(
        !this.currentVariant.available,
        ''
      );
    }

    // 创建 dropdown
    this.createDropdownFromButtons();

    // 启用 dropdown UI
    this.enableDropdownStyle();
  }


  /* =========================================================
     Variant Availability
     ========================================================= */

  updateVariantStatuses() {
    const inputWrappers = [
      ...this.querySelectorAll(this.inputWrapper)
    ];

    inputWrappers.forEach((optionWrapper, optionIndex) => {

      // 读取其他 option 当前的选中值
      const selectedValues = inputWrappers.map(
        (wrapper, idx) => {

          if (idx === optionIndex) {
            return null;
          }

          const checked = wrapper.querySelector(':checked');

          return checked
            ? checked.value
            : null;
        }
      );


      // 找到当前组合下可用的值
      const possibleValues = this.variants

        .filter(variant => {

          return selectedValues.every(
            (val, idx) => {

              if (val === null) {
                return true;
              }

              return (
                variant[`option${idx + 1}`] === val
              );

            }
          ) && variant.available;

        })

        .map(
          variant =>
            variant[`option${optionIndex + 1}`]
        );


      const optionInputs = [
        ...optionWrapper.querySelectorAll(
          'input[type="radio"], option'
        )
      ];


      optionInputs.forEach(input => {

        const value =
          input.getAttribute('value');

        const isAvailable =
          possibleValues.includes(value);


        // 如果设置了 data-stock，则保持原逻辑
        if (input.getAttribute('data-stock')) {
          return;
        }

        input.disabled = !isAvailable;


        /*
         * dropdown 中的 option
         * 同步 button disabled 状态
         */
        if (
          input.tagName.toLowerCase() === 'option'
        ) {

          const escapedValue =
            input.value.replace(/"/g, '\\"');

          const selector =
            `button[data-value="${escapedValue}"]`;

          const dropdown =
            input.closest('dropdown-input');

          const button =
            dropdown
              ? dropdown.querySelector(selector)
              : null;

          if (button) {
            button.disabled = !isAvailable;
          }
        }


        // Product Bar
        if (!this.productBar) {
          return;
        }

        const inputId =
          input.dataset.id || input.id;

        const productBarInput =
          this.productBar.querySelector(
            `option[data-id="${inputId}"]`
          );

        if (!productBarInput) {
          return;
        }

        productBarInput.disabled =
          !isAvailable;
      });
    });
  }


  /* =========================================================
     Variant Change
     ========================================================= */

  onVariantChange(event) {

    /*
     * ★ 重要
     *
     * Variant 变化只认 radio。
     *
     * 防止：
     * select change
     * hidden variant input change
     * quantity input change
     *
     * 再次触发整个 SKU 更新流程。
     */
    if (
      !event.target.matches(
        'input[type="radio"]'
      )
    ) {
      return;
    }


    const previousVariantId =
      this.currentVariant
        ? this.currentVariant.id
        : null;


    /*
     * 第一步：
     * 读取用户当前真正选择的 option
     */
    this.updateOptions();


    /*
     * 第二步：
     * 根据 option 找 Variant
     */
    this.updateVariant();


    /*
     * 如果 Variant 完全没有变化，
     * 不重复更新页面。
     */
    if (
      this.currentVariant &&
      previousVariantId ===
        this.currentVariant.id
    ) {
      return;
    }


    // Sticky product bar
    this.productBarUpdateOptions();


    /*
     * 找不到 Variant
     */
    if (!this.currentVariant) {

      if (this.form) {
        this.form.toggleAddButton(
          true,
          ''
        );
      }

      this.setUnavailable();

      return;
    }


    /*
     * Pickup availability
     */
    this.updatePickupAvailability();


    /*
     * Product form
     */
    if (this.form) {

      this.form.handleErrorMessage();

      if (this.currentVariant.available) {

        this.form.toggleAddButton(
          false,
          ''
        );

      } else {

        this.form.toggleAddButton(
          true,
          window.theme.strings.soldOut
        );
      }
    }


    /*
     * 更新媒体
     */
    this.updateMedia();


    /*
     * 更新浏览器 URL
     */
    this.updateURL();


    /*
     * 更新 Variant ID
     */
    this.updateVariantInput();


    /*
     * 更新价格、购买选项、库存等
     */
    this.renderProductInfo();
  }


  /* =========================================================
     Read Selected Options
     ========================================================= */

  updateOptions() {

    const wrappers = [
      ...this.querySelectorAll(
        this.inputWrapper
      )
    ];


    /*
     * 更新 is-active
     */
    this.querySelectorAll(
      'input[type="radio"]'
    ).forEach(input => {

      const item =
        input.closest(
          '.product-options__item'
        );

      if (item) {

        item.classList.toggle(
          'is-active',
          input.checked
        );

      }
    });


    /*
     * ★ 重要修改
     *
     * 一个 Option Wrapper
     * 只允许产生一个 value。
     *
     * 不再同时读取：
     *
     * radio + select
     *
     * 避免 Size=M 和 Size=L
     * 同时进入 variant 判断。
     */
    this.options = wrappers

      .map(wrapper => {

        const checkedRadio =
          wrapper.querySelector(
            'input[type="radio"]:checked'
          );

        const select =
          wrapper.querySelector(
            'select'
          );


        /*
         * Radio 是主数据源
         */
        const activeInput =
          checkedRadio || select;


        if (!activeInput) {
          return null;
        }


        /*
         * 如果同时存在 select，
         * 强制让 select 跟 radio 保持一致
         */
        if (
          checkedRadio &&
          select &&
          select.value !==
            checkedRadio.value
        ) {

          select.value =
            checkedRadio.value;

        }


        return {

          name:
            activeInput.dataset.name ||
            activeInput.name,

          value:
            activeInput.value
        };

      })

      .filter(Boolean);
  }


  /* =========================================================
     Product Bar
     ========================================================= */

  productBarUpdateOptions() {

    if (!this.productBar) {
      return;
    }


    Array.from(
      this.productBar.querySelectorAll(
        'select'
      )
    ).forEach(selector => {

      const matchingOption =
        this.options.find(
          option =>
            option.name === selector.name
        );


      if (matchingOption) {

        selector.value =
          matchingOption.value;

      }
    });


    this.productBar
      .querySelectorAll(
        'dropdown-input'
      )
      .forEach(dropdown => {

        if (
          typeof dropdown.update ===
          'function'
        ) {

          dropdown.update();

        }

      });
  }


  /* =========================================================
     Inventory Notice
     ========================================================= */

  updateInventoryNotice(html) {

    const destination =
      document.querySelector(
        '[data-inventory-notice]'
      );

    const source =
      html.querySelector(
        '[data-inventory-notice]'
      );


    if (
      source &&
      destination
    ) {

      destination.innerHTML =
        source.innerHTML;

    }


    /*
     * 从库存提示中读取数字
     */
    const inventoryQuantityMatch =
      source
        ? source.textContent.match(/\d+/)
        : null;


    const inventoryQuantity =
      inventoryQuantityMatch
        ? parseInt(
            inventoryQuantityMatch[0],
            10
          )
        : 0;


    this.updateQuantityInput(
      inventoryQuantity
    );
  }


  /* =========================================================
     Quantity
     ========================================================= */

  updateQuantityInput(
    inventoryQuantity
  ) {

    const selectedVariantData =
      this.getVariantData();


    const quantityInput =
      document.querySelector(
        '.product-selector__quantity quantity-input input'
      );


    let productUsesInventory =
      true;


    /*
     * Shopify 没有管理库存
     */
    if (
      selectedVariantData &&
      selectedVariantData
        .inventory_management === null
    ) {

      productUsesInventory =
        false;

    }


    /*
     * Continue selling when out of stock
     */
    if (
      selectedVariantData &&
      selectedVariantData
        .inventory_quantity !== null &&
      inventoryQuantity === 0 &&
      selectedVariantData.available === true
    ) {

      productUsesInventory =
        false;

    }


    if (!quantityInput) {
      return;
    }


    if (productUsesInventory) {

      quantityInput.setAttribute(
        'max',
        inventoryQuantity
      );


      if (
        Number(quantityInput.value) >
        inventoryQuantity
      ) {

        quantityInput.value =
          inventoryQuantity;

      }

    } else {

      quantityInput.removeAttribute(
        'max'
      );

    }
  }


  /* =========================================================
     Pickup Availability
     ========================================================= */

  updatePickupAvailability() {

    const pickUpAvailabilityNode =
      document.querySelector(
        'pickup-availability'
      );


    if (
      !pickUpAvailabilityNode ||
      !this.currentVariant
    ) {
      return;
    }


    pickUpAvailabilityNode.dataset.variantId =
      this.currentVariant.id;


    if (
      this.currentVariant.available
    ) {

      pickUpAvailabilityNode.setAttribute(
        'available',
        ''
      );


      pickUpAvailabilityNode
        .fetchAvailability(
          pickUpAvailabilityNode
            .dataset.variantId
        );


      return;
    }


    pickUpAvailabilityNode
      .removeAttribute(
        'available'
      );

    pickUpAvailabilityNode.innerHTML =
      '';
  }


  /* =========================================================
     Current Variant
     ========================================================= */

  updateVariant() {

    this.currentVariant =
      this.getVariantData();

  }


  getVariantData() {

    if (
      !this.options ||
      this.options.length === 0
    ) {

      return this.variants[0];

    }


    /*
     * ★ 简化 Variant 匹配
     *
     * 第 1 个 wrapper → option1
     * 第 2 个 wrapper → option2
     * 第 3 个 wrapper → option3
     */
    return this.variants.find(
      variant => {

        return this.options.every(
          (option, index) => {

            return (
              variant[
                `option${index + 1}`
              ] === option.value
            );

          }
        );

      }
    );
  }


  /* =========================================================
     Initial Media
     ========================================================= */

  initUpdateMedia() {

    const urlParams =
      new URLSearchParams(
        window.location.search
      );


    const variantIdFromUrl =
      parseInt(
        urlParams.get('variant'),
        10
      );


    if (!variantIdFromUrl) {
      return;
    }


    const variant =
      this.variants.find(
        variant =>
          variant.id ===
          variantIdFromUrl
      );


    if (!variant) {
      return;
    }


    this.currentVariant =
      variant;


    this.updateMedia();
  }


  /* =========================================================
     Media
     ========================================================= */

  updateMedia() {

    if (
      !this.currentVariant ||
      !this.currentVariant.featured_media
    ) {
      return;
    }


    const productMedia =
      document.querySelector(
        'product-media'
      );


    if (
      !productMedia ||
      typeof productMedia
        .setActiveMedia !== 'function'
    ) {
      return;
    }


    productMedia.setActiveMedia(
      this.currentVariant
        .featured_media.id
    );
  }


  /* =========================================================
     URL
     ========================================================= */

  updateURL(sellingPlanId) {

    if (!this.currentVariant) {
      return;
    }


    const params =
      new URLSearchParams(
        window.location.search
      );


    params.set(
      'variant',
      this.currentVariant.id
    );


    if (sellingPlanId) {

      params.set(
        'selling_plan',
        sellingPlanId
      );

    } else {

      params.delete(
        'selling_plan'
      );

    }


    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`
    );
  }


  /* =========================================================
     Variant ID Input
     ========================================================= */

  updateVariantInput() {

    if (!this.currentVariant) {
      return;
    }


    const inputs = [

      this.querySelector(
        '[name="id"]'
      ),

      this.installmentsForm
        ? this.installmentsForm
            .querySelector(
              '[name="id"]'
            )
        : null

    ];


    inputs.forEach(input => {

      if (!input) {
        return;
      }


      input.value =
        this.currentVariant.id;


      /*
       * 仍然保留 change，
       * 供主题其他组件监听。
       *
       * 但 onVariantChange
       * 现在只响应 radio，
       * 所以不会形成递归。
       */
      input.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );

    });
  }


  /* =========================================================
     Unavailable
     ========================================================= */

  setUnavailable() {

    const submitButton =
      this.form
        ? this.form.submitButton
        : null;


    const price =
      this.querySelector(
        `#Product-Price-${this.dataset.sectionId}`
      );


    if (!submitButton) {
      return;
    }


    submitButton.textContent =
      window.theme.strings.unavailable;


    if (price) {

      price.classList.add(
        'visibility-hidden'
      );

    }
  }


  /* =========================================================
     Create Dropdown From Radios
     ========================================================= */

  createDropdownFromButtons() {

    const inputWrappers =
      this.querySelectorAll(
        this.inputWrapper
      );


    inputWrappers.forEach(
      wrapper => {

        const radios =
          wrapper.querySelectorAll(
            'input[type="radio"]'
          );


        const selectWrapper =
          wrapper.querySelector(
            '[data-select-wrapper]'
          );


        const select =
          wrapper.querySelector(
            '[data-select]'
          );


        if (
          !radios.length ||
          !selectWrapper ||
          !select
        ) {
          return;
        }


        /*
         * 清空旧 option
         */
        select.innerHTML = '';


        /*
         * 根据 radio 重新创建 select
         */
        radios.forEach(
          radio => {

            const option =
              document.createElement(
                'option'
              );


            option.value =
              radio.value;


            option.textContent =
              radio.value;


            if (radio.checked) {

              option.selected =
                true;

            }


            if (radio.disabled) {

              option.disabled =
                true;

            }


            select.appendChild(
              option
            );

          }
        );


        /*
         * Select 切换
         */
        select.addEventListener(
          'change',
          e => {

            /*
             * ★ 非常重要
             *
             * 阻止 select 自己的 change
             * 再冒泡到 product-selector。
             *
             * 下面只派发一次 radio change。
             */
            e.stopPropagation();


            const selectedValue =
              e.target.value;


            /*
             * 清除当前 wrapper
             * 所有 radio 状态
             */
            radios.forEach(
              radio => {

                radio.checked =
                  false;


                const item =
                  radio.closest(
                    '.product-options__item'
                  );


                if (item) {

                  item.classList.remove(
                    'is-active'
                  );

                }
              }
            );


            /*
             * 找到对应 radio
             */
            const targetRadio =
              Array.from(
                radios
              ).find(
                radio =>
                  radio.value ===
                  selectedValue
              );


            if (!targetRadio) {
              return;
            }


            targetRadio.checked =
              true;


            const targetItem =
              targetRadio.closest(
                '.product-options__item'
              );


            if (targetItem) {

              targetItem.classList.add(
                'is-active'
              );

            }


            /*
             * ★ 只触发一次 Variant Change
             */
            targetRadio.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );

          }
        );


        selectWrapper.classList.remove(
          'hidden'
        );

      }
    );
  }


  /* =========================================================
     Render Product Info
     ========================================================= */

  renderProductInfo() {

    if (!this.currentVariant) {
      return;
    }


    /*
     * ★ 非常重要
     *
     * 快速切换 SKU 时，
     * 取消上一次请求。
     *
     * 防止：
     *
     * 点 M
     * ↓
     * 点 S
     * ↓
     * S 先返回
     * ↓
     * M 后返回
     * ↓
     * 旧数据覆盖新数据
     */
    if (this.renderRequestController) {

      this.renderRequestController.abort();

    }


    this.renderRequestController =
      new AbortController();


    const controller =
      this.renderRequestController;


    const requestedVariantId =
      this.currentVariant.id;


    const params =
      new URLSearchParams(
        window.location.search
      );


    params.set(
      'variant',
      requestedVariantId
    );


    params.set(
      'section_id',
      this.dataset.sectionId
    );


    fetch(
      `${this.dataset.url}?${params.toString()}`,
      {
        signal:
          controller.signal
      }
    )

      .then(response => {

        if (!response.ok) {

          throw new Error(
            `Product info request failed: ${response.status}`
          );

        }

        return response.text();

      })


      .then(responseText => {

        /*
         * 如果用户已经切到另一个 Variant，
         * 当前响应直接丢弃。
         */
        if (
          !this.currentVariant ||
          this.currentVariant.id !==
            requestedVariantId
        ) {

          return;

        }


        const html =
          new DOMParser()
            .parseFromString(
              responseText,
              'text/html'
            );


        /*
         * Inventory Notice
         * 只更新一次
         */
        this.updateInventoryNotice(
          html
        );


        const selectors = [

          `#Product-Price-${this.dataset.sectionId}`,

          `#Product-Purchase-Options-${this.dataset.sectionId}`

        ];


        selectors.forEach(
          liveRegionSelector => {

            const destination =
              document.querySelector(
                liveRegionSelector
              );


            const source =
              html.querySelector(
                liveRegionSelector
              );


            if (
              destination &&
              source
            ) {

              destination.classList.remove(
                'visibility-hidden'
              );


              destination.innerHTML =
                source.innerHTML;

            }

          }
        );

      })


      .catch(error => {

        /*
         * 用户主动切 SKU
         * 导致请求取消属于正常行为
         */
        if (
          error.name ===
          'AbortError'
        ) {

          return;

        }


        console.error(
          'Product info update error:',
          error
        );

      });
  }


  /* =========================================================
     Dropdown UI
     ========================================================= */

  enableDropdownStyle() {

    const wrappers =
      Array.from(
        this.querySelectorAll(
          '.js-product-options-value-list'
        )
      );


    wrappers.forEach(
      wrapper => {

        /*
         * Buttons 模式不用 dropdown
         */
        if (
          wrapper.closest(
            '.product-selector--buttons'
          )
        ) {
          return;
        }


        wrapper.dataset.open =
          'false';


        wrapper.addEventListener(
          'click',
          e => {

            const isOpen =
              wrapper.dataset.open ===
              'true';


            const target =
              e.target;


            const optionItem =
              target.closest(
                '.product-options__item'
              );


            /*
             * 点击某个 option
             */
            if (optionItem) {

              const radioInput =
                optionItem.querySelector(
                  'input[type="radio"]'
                );


              /*
               * 点击的是未选中的 SKU
               */
              if (
                radioInput &&
                !radioInput.disabled &&
                !radioInput.checked
              ) {

                /*
                 * ★ 阻止 label/input
                 * 再触发一次原生选择
                 */
                e.preventDefault();


                const allRadiosInGroup =
                  wrapper.querySelectorAll(
                    'input[type="radio"]'
                  );


                allRadiosInGroup.forEach(
                  radio => {

                    radio.checked =
                      false;


                    const item =
                      radio.closest(
                        '.product-options__item'
                      );


                    if (item) {

                      item.classList.remove(
                        'is-active'
                      );

                    }

                  }
                );


                /*
                 * 设置当前 radio
                 */
                radioInput.checked =
                  true;


                optionItem.classList.add(
                  'is-active'
                );


                /*
                 * ★ 只 dispatch 一次
                 */
                radioInput.dispatchEvent(
                  new Event(
                    'change',
                    {
                      bubbles: true
                    }
                  )
                );


                /*
                 * 选择完成后关闭
                 */
                wrapper.dataset.open =
                  'false';


                e.stopPropagation();

                return;
              }


              /*
               * 点击当前已经选中的值
               * 用来打开 / 关闭 dropdown
               */
              wrapper.dataset.open =
                isOpen
                  ? 'false'
                  : 'true';


              e.stopPropagation();

              return;
            }


            /*
             * 点击箭头或 wrapper 空白区域
             */
            wrapper.dataset.open =
              isOpen
                ? 'false'
                : 'true';


            e.stopPropagation();

          }
        );

      }
    );


    /*
     * 点击页面其他位置，
     * 关闭所有 dropdown
     */
    window.addEventListener(
      'click',
      e => {

        wrappers.forEach(
          wrapper => {

            if (
              !wrapper.contains(
                e.target
              )
            ) {

              wrapper.dataset.open =
                'false';

            }

          }
        );

      }
    );
  }
}


customElements.define(
  'product-selector',
  ProductSelector
);